console.log("hii");

class ClearCartSubmit extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const form = this.closest("form");
    if (form) {
      const submitButton = form.querySelector('button[type="submit"]');

      // Attach event listener to the submit button
      if (submitButton) {
        submitButton.addEventListener("click", (e) => {
          e.preventDefault();

          fetch("/cart/clear.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
          })
            .then((response) => response.json())
            .then(() => {
              form.submit();
            })
            .catch((error) => {
              console.error("Error clearing the cart:", error);
            });
        });
      }
    }
  }
}
customElements.define("clear-cart-submit", ClearCartSubmit);
